import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex';
import { getBuyerList } from '@/api/sys.user';
import store from '@/store/index';
export default {
  components: {},
  data: function data() {
    return {
      columnConfig: {
        resizable: true
      },
      tabelData: [],
      code: '',
      formData: {
        Page: 1,
        // 当前页
        Limit: 15,
        // 分页大小
        Data: {
          ORGANIZE_ID: 385 // Code: '',
          // BillTypeIds: [199694499110981]

        }
      },
      pageInfo: {
        TotalCount: 1,
        PageSize: 10,
        PageIndex: 1
      }
    };
  },
  created: function created() {
    this.getLoadData();
  },
  methods: {
    refreshReset: function refreshReset() {},
    handelAddBtn: function handelAddBtn() {},
    // 获取列表
    getLoadData: function getLoadData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                params = {
                  Page: 1,
                  Limit: 10,
                  Key: null,
                  LIST_ROUTE: store.getters.routerPath
                };
                _context.next = 4;
                return getBuyerList(params);

              case 4:
                res = _context.sent;
                console.log('表格数据 res', res);
                _this.loading = false;

                if (res.code === 0) {
                  _this.tabelData = res.data.filter(function (item) {
                    return item.TYPE_ID === '1';
                  });
                  _this.pageInfo.TotalCount = res.data.TotalCount;
                  _this.pageInfo.PageSize = res.data.PageSize;
                  _this.pageInfo.PageIndex = res.data.PageIndex;
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};